import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const template = document.createElement('template')
template.innerHTML = `
  <div>
    <slot></slot>
  <div>
`
class NavHeaderContextualNewMenu extends HTMLElement {
  constructor() {
      super()
  
      tryLoadDependencies(document, [WebAwesomeComponent.Icon])
  
      const shadow = this.attachShadow({ mode: 'open' })
      shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
      shadow.appendChild(template.content.cloneNode(true))
    }
  connectedCallback() {
    
  }
}

customElements.define('ts-navheader-contextual-new-menu', NavHeaderContextualNewMenu)
